import React, { createContext, useCallback, useEffect, useState } from "react";

const UserContext = createContext();

const UserContextProvider = (appProps) => {
  // the value that will be given to the context
  const [profileNeeded] = useState(true);
  const [pageId, setPageId] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const [jobs] = useState({});
  const [settingData] = useState();

  const [view, setView] = useState("candidate");
  const [isEmployer] = useState(false);
  const [user, setUser] = useState();
  const [hotels] = useState();
  const [loadingNewPage, setLoadingNewPage] = useState(false);
  const addPageId = useCallback(() => {
    setPageId((currentPageId) => currentPageId + 1);
  }, []);

  // let mounted = false;
  // useEffect(() => {
  //   if (!mounted) {
  //     getHotels();
  //     checkRole();
  //   }

  //   return () => {
  //     mounted = true;
  //   };
  // }, []);

  useEffect(() => {
    addPageId();
  }, [addPageId, loadingNewPage]);

  return (
    // the Provider gives access to the context to its children
    <UserContext.Provider
      value={{
        hotels,
        user,
        setUser,
        pageId,
        addPageId,
        settingData,
        isLoading,
        setLoading,

        view,
        setView,
        isEmployer,

        profileNeeded,
        jobs,

        loadingNewPage,
        setLoadingNewPage,
      }}
    >
      {appProps.children}
    </UserContext.Provider>
  );
};

export { UserContext, UserContextProvider };
